// const serverIP = 'http://192.168.12.167:8031/rest'
// const serverIP = 'http://192.168.12.167:8080/rest'
// const serverIP = 'http://192.168.12.127:8031/rest'
// const serverIP = 'http://192.168.12.187:8031/rest'
// const serverIP = 'http://samex.iok.la:28001/rest'
// const serverIP = 'http://test.samexsys.com/samex/rest'
//const serverIP = 'http://192.168.10.153:8001/rest'
//const serverIP = 'http://192.168.10.159:8090/samex/rest'
//const serverIP = 'http://samex.iok.la:1801/rest'
//const serverIP = 'http://testjllhk.etender1.com:8000/samex/rest'
//const serverIP = 'http://113.118.10.135:1801/rest'
//const serverIP = 'http://hk.gympro1.com/samex/rest'
//const serverIP = 'http://192.168.10.161:8001/rest'
//const serverIP = 'https://jllhktest.samexsys.com/samex/rest'
//const rptServerIP = 'https://jllhktest.samexsys.com/p2report/frameset?__report='
//const serverIP = 'http://testjllhk.etender1.com:8000/samex/rest'
//const serverIP = 'http://samex.iok.la:8000/samex/rest'
//const rptServerIP = 'http://192.168.10.159:8090/p2report/frameset?__report='
//const serverIP = 'http://154.85.53.120:8000/samex/rest'
//const rptServerIP = 'http://154.85.53.120:8000/p2report/frameset?__report='
const serverIP = 'https://jllhk.etender1.com/samex/rest'
const rptServerIP = 'https://jllhk.etender1.com/p2report/frameset?__report='
let url = {
    'userLogin': '/login/userlogin',
    'userLogout': '/login/userlogout',
    'getList': '/util/list',
    'update': '/util/update',
    'submitWorkflow': '/workflow/submitworkflow',
    'changePassword':'/account/editaccount',
    'getVercode':'/common/gencode',
    'validate':'/common/verification',
    'checkSession': '/checksession',
}

export const getRequestIP = (action) => {
    return serverIP + url[action]
}

export const getRptIP = (rptName, params) => {
    let url = rptServerIP + rptName + ".rptdesign";
    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            const element = params[key];
            url = url + '&' + key + '='+ element;
        }
    }
    return url
}